import client from "../Client/HttpClient";
import {IMenuModel} from "@/interfaces/modules";
const ApiPath = "SystemMenu";

export default {
    GetMenu:(): Promise <IMenuModel[]> => client.get(`${ApiPath}`),
    GetMenuById: (data: IMenuModel ):Promise<IMenuModel>=>client.get(`${ApiPath}/${data.Id}`),
    PostMenu : (data:IMenuModel ) : Promise<IMenuModel>=>client.post(`${ApiPath}`, data),
  };